import React from 'react';
import { Stack, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import LockIconWrapper from '../../../components/LockIconWrapper';

function ActionButtons({
  booking,
  isTodayorFutue,
  hasUpdateRights,
  isEditable,
  hasUnlimitedEditRights,
  onAddPackageClick,
  onAddUpsellClick,
  hasAddCategoryRights = false,
  allCategoriesUsed = false,
  onAddCategoryClick,
  hasSpecialItemRights = false,
  onAddSpecialItemClick,
}) {
  return (
    <Stack mt={2} spacing={2} direction={{ xs: 'column', sm: 'row' }}>
      {(!booking.selectedPackage || !booking.selectedPackage?.upgradeId) &&
        (isTodayorFutue || hasUnlimitedEditRights) &&
        booking.status !== 'blocked' &&
        hasUpdateRights && (
          <Button
            data-testid='booking-details-add-package'
            variant='contained'
            color='success'
            startIcon={<AddIcon />}
            onClick={onAddPackageClick}
            disabled={!isEditable}
            sx={{
              '&.Mui-disabled': {
                backgroundColor: 'rgba(76, 175, 80, 0.3)',
                color: 'rgba(0, 0, 0, 0.5)',
              },
            }}
          >
            <LockIconWrapper right={'internalBooking:update:own'}>Paket hinzufügen</LockIconWrapper>
          </Button>
        )}
      {booking.status !== 'blocked' &&
        booking.status !== 'canceled' &&
        (isTodayorFutue || hasUnlimitedEditRights) &&
        hasUpdateRights && (
          <Button
            data-testid='booking-details-add-upsell'
            variant='contained'
            color='success'
            startIcon={<AddIcon />}
            onClick={onAddUpsellClick}
            disabled={!isEditable}
            sx={{
              '&.Mui-disabled': {
                backgroundColor: 'rgba(76, 175, 80, 0.3)',
                color: 'rgba(0, 0, 0, 0.5)',
              },
            }}
          >
            <LockIconWrapper right={'internalBooking:update:own'}>
              Upsell hinzufügen
            </LockIconWrapper>
          </Button>
        )}
      {booking.status !== 'blocked' &&
        booking.status !== 'canceled' &&
        (isTodayorFutue || hasUnlimitedEditRights) &&
        hasAddCategoryRights &&
        !allCategoriesUsed && (
          <Button
            variant='contained'
            color='success'
            startIcon={<AddIcon />}
            onClick={onAddCategoryClick}
            disabled={!isEditable}
            sx={{
              '&.Mui-disabled': {
                backgroundColor: 'rgba(76, 175, 80, 0.3)',
                color: 'rgba(0, 0, 0, 0.5)',
              },
            }}
          >
            <LockIconWrapper right={'internalBooking:update'}>
              Personenkategorie hinzufügen
            </LockIconWrapper>
          </Button>
        )}
      {booking.status !== 'blocked' && hasSpecialItemRights && (
        <Button
          variant='contained'
          color='success'
          startIcon={<AddIcon />}
          onClick={onAddSpecialItemClick}
        >
          Sonder-Item hinzufügen
        </Button>
      )}
    </Stack>
  );
}

export default ActionButtons;
